import AppPublic from './AppPublic';
new AppPublic().start();